import { useEffect } from 'react';

const envDisabled = import.meta.env.VITE_DISABLE_FULLSCREEN === 'true';

type UseForceFullscreenOptions = {
  disabled?: boolean;
};

/**
 * Force fullscreen on first click unless disabled.
 */
export function useForceFullscreen(options?: UseForceFullscreenOptions) {
  const isDisabled = options?.disabled ?? envDisabled;

  useEffect(() => {
    if (isDisabled) return;

    const goFullscreen = () => {
      document.documentElement.requestFullscreen();
      document.removeEventListener('click', goFullscreen);
    };
    document.addEventListener('click', goFullscreen);
    return () => {
      document.removeEventListener('click', goFullscreen);
    };
  }, [isDisabled]);
}
